import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import SocialMediaLinks from "../SocialMediaLinks/SocialMediaLinks";
import { STORE_PHONE_PRIMARY, STORE_PHONE_ALT } from "../../constants/storeContact";

const logo = `${process.env.PUBLIC_URL || ""}/gemlogo.png`;
const paymentIcon = `${process.env.PUBLIC_URL || ""}/razorpaylogo_7313.png`;

/** Match header nav URLs (`Navbar.jsx` FALLBACK_LINKS); filters are handled by `/api/products`. */
const FOOTER_SHOP_LINKS = [
  { label: "Collections", to: "/shop" },
  { label: "Mens", to: "/shop?gender=male" },
  { label: "Womens", to: "/shop?gender=female" },
  { label: "Festive Vibes", to: "/shop?category=Festive%20vibes" },
  { label: "Occasion", to: "/shop?category=Occasion" },
  { label: "Browse all rentals", to: "/shop" },
];

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    alert("Subscribed Successfully");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          <div className="footer_left">
            <div className="footer_logo_container">
              <img src={logo} alt="Gem Fashion Studios" />
            </div>

            <p>GEM House, 5/54, RSC-2, Four Bungalows, Mhada Rd, SV Patel Nagar, Andheri West, Mumbai, Maharashtra 400053</p>

            <div className="footer_address">
              <strong><a href="mailto:gemboutiqueinquiries@gmail.com">gemboutiqueinquiries@gmail.com</a></strong>
              <strong>
                <a href={`tel:${STORE_PHONE_PRIMARY.tel}`}>{STORE_PHONE_PRIMARY.display}</a>
                {" · "}
                <a href={`tel:${STORE_PHONE_ALT.tel}`}>{STORE_PHONE_ALT.display}</a>
              </strong>
            </div>

            <SocialMediaLinks className="social_links" />
          </div>

          <div className="footer_content">
            <h5>Categories</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                {FOOTER_SHOP_LINKS.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Information</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/career">Career</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/terms">Terms &amp; conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy policy</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Cookie policy</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping policy</Link>
                </li>
                <li>
                  <Link to="/refund-policy">Refund policy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h5>Account</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/contact">Customer Service</Link>
                </li>
                <li>
                  <Link to="/loginSignUp">My Account</Link>
                </li>
                <li>
                  <Link to="/contact">Find a Store</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer_right">
            <h5>Subscribe</h5>
            <p>
              New rental arrivals, style tips and exclusive offers—right in your inbox.
            </p>

            <form onSubmit={handleSubscribe}>
              <input type="email" placeholder="Your email address" required />
              <button type="submit">Join</button>
            </form>

            <h6>Secure Payments</h6>
            <div className="paymentIconContainer">
              <img src={paymentIcon} alt="" />
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <p>
            © 2026 Gem Fashion Studios. All Rights Reserved.{" "}
            <span className="footer_poweredby">Powered by <a href="https://nekdigital.nl" target="_blank" rel="noopener noreferrer">Nek Digital</a></span>
          </p>
          <nav className="footerPaymentEssentials" aria-label="Checkout and payments">
            <Link to="/terms" onClick={scrollToTop}>
              Terms &amp; conditions
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/privacy-policy" onClick={scrollToTop}>
              Privacy policy
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/cookie-policy" onClick={scrollToTop}>
              Cookie policy
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/shipping-policy" onClick={scrollToTop}>
              Shipping policy
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/refund-policy" onClick={scrollToTop}>
              Refund policy
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/cart" onClick={scrollToTop}>
              Cart &amp; checkout
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/account/orders" onClick={scrollToTop}>
              Order history
            </Link>
            <span className="footerPaymentEssentials__sep" aria-hidden>
              |
            </span>
            <Link to="/contact" onClick={scrollToTop}>
              Payment support
            </Link>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default Footer;
